import { Route } from "react-router-dom";

const RouteWrapper = ({ component: Component, layout: Layout, ...rest }) => {
  return (
    <Route {...rest}>
      <Layout {...rest}>
        <Component {...rest} />
      </Layout>
    </Route>
  );
};

export default RouteWrapper;
